<template>
    <div class="FamilyList" v-observe-visibility="VisibilityChanged" style="display:flex;flex-direction:column; max-height:85vh;">
        <div ref="divtophalf">
            <h2>
                Resource Family Enrollments
                <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer table-refresh client-list" />
                <span v-b-tooltip.hover title="Hide/Show Filters" style="margin-left:6px;margin-right:6px;">
                    <font-awesome-icon :icon="ShowFilters ? 'eye' : 'eye-slash'" v-on:click="ToggleShowFilters()" class="pointer" />
                </span>
                <EmployeeColumnCustomizationEditor update-event-message="update-table-columns" :table-fields="VisibleFields" table-label="Family List" columns-defaults-endpoint="Foster/ResourceFamily/GetTableColumns" table-settings-name="Foster Family Table">
                </EmployeeColumnCustomizationEditor>
            </h2>
            <div class="table-filters client-list" v-show="ShowFilters">
                <div class="row">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>Family Status:</label>
                            <select class="form-control" v-model="Filters.FamilyStatus" @change="RefreshDataTable()">
                                <option value="All">All</option>
                                <option value="Inquiries">Inquiries</option>
                                <option value="All Applicants">All Applicants</option>
                                <option v-if="CheckRestriction('Foster.Families.List.RestrictToSimpleView')" value="Preapproved Applicants">Preapproved Applicants</option>
                                <option v-if="CheckRestriction('Foster.Families.List.RestrictToSimpleView')" value="Approved/Licensed">Approved/Licensed</option>
                                <option value="Active">Active</option>
                                <option v-if="CheckRestriction('Foster.Families.List.RestrictToSimpleView')" value="Inactive">Inactive</option>
                                <option value="Application Closed">Application Closed</option>
                                <option value="Approval/License Rescinded/Forfeited">Approval/License Rescinded/Forfeited</option>
                                <option value="Transferred">Transferred</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>Program:</label>
                            <select class="form-control" v-model="Filters.SubProgramID" @change="RefreshDataTable()">
                                <option v-if="CheckPermission('CanAccessAllOptionInSubPrograms')" value="">All</option>
                                <option v-for="option in SubProgramOptions" v-bind:value="option.value">{{ option.text }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>ASW:</label>
                            <select class="form-control" v-model="Filters.ASWID" @change="RefreshDataTable()">
                                <option value="">All</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        Displaying {{NumberOfFamilies}} Records
                    </div>
                    <div class="col-sm-4"></div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>Search Families:</label>
                            <input type="text" v-model="search" class="form-control" @input="RedrawTable()" />
                            <!--<input type="text" class="form-control" v-model="TableSearch" />-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="overflow-x:auto;">
            <vuetable :fields="VisibleFields"
                      pagination-path=""
                      :api-mode="false"
                      class="vue-datatable"
                      :data-manager="DataManager"
                      ref="datatable"
                      :row-class="onRowClass">
                <template slot="FamilyRecordLink" scope="props">
                    <div class="FamilyRecordLink">
                        <span class="underline pointer" @click="OpenFamilyRecord(props.rowData.Family.Id, props.rowData)" v-html="StyleFamilyName(props.rowData)"></span>
                    </div>
                </template>
                <template slot="ServiceLogShortcut" scope="props">
                    <div class="ServiceLogShortcut">
                        <font-awesome-icon icon="book" @click="OpenServiceLogAdder(props.rowData.Family.Id, props.rowData.Family.Name)" class="pointer" />
                    </div>
                </template>
            </vuetable>
        </div>
        <ServiceLogAdder ref="familyservicelogaddercomponent" add-endpoint="Foster/FamilyServiceLog/AddUpdateEntry" :categories="FamilyServiceLogCategories" />
    </div>
</template>

<script>
     //import components
    //import Vue from 'vue';
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    import { EventBus } from '../../../services/event-bus.js';
    import EmployeeColumnCustomizationEditor from "../../Core/ItemEditors/EmployeeColumnCustomizationEditor.vue";
    import ServiceLogAdder from "../../Core/ItemEditors/ServiceLogAdder.vue";
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faBook } from '@fortawesome/free-solid-svg-icons';
    library.add(faBook);

    
    //MIXINS
    import { TableScrollerSupport } from "../../../mixins/TableScrollerSupport.js";

    export default {
        mixins: [
            TableScrollerSupport
        ],
        created() {
            let vm = this;
            //EventBus.$on('update-family-list', val => {
            //    //vm.GetFamiliesSingularRecord();
            //});
            //EventBus.$on('open-family-record', val => {
            //    vm.GetFamiliesSingularRecord();
            //});
            EventBus.$on('global-update-initiated', this.GetFamilies);
            EventBus.$on('update-table-columns', this.RefreshDataTable);
        },
        beforeDestroy() {
            EventBus.$off('global-update-initiated');
            EventBus.$off('update-table-columns');
        },
        props: [],
        data: function () {
            return {
                NumberOfFamilies: '',
                SingleRecord: [],
                search: "",
                VisibleFields: [],
                Filters: {
                    FamilyStatus: "Active",
                    SubProgramID: "",
                    ASWID: ""
                },
                FamilyTableOptions: {
                    Fields: [
                        {
                            name: '__slot:FamilyRecordLink',
                            title: 'Name',
                            sortField: 'Family.Name'
                        },
                        {
                            name: '__slot:ServiceLogShortcut',
                            title: 'Add Log'
                        },
                        {
                            name: 'Family.Name',
                            title: 'Name',
                            visible: false,
                            Save: true
                        },
                        {
                            name: 'FamilyProgramMembership.SubProgramName',
                            title: "Program",
                            sortField: 'FamilyProgramMembership.SubProgramName'
                        },
                        {
                            name: 'Family.Status',
                            title: "Status",
                            sortField: 'Family.Status'
                        },
                        {
                            name: 'Family.StatusDate',
                            title: "Status Date",
                            callback: 'formatDate|MM/DD/YY',
                            sortField: 'Family.StatusDate'
                        },
                        {
                            name: 'Family.AvailableBedsString',
                            title: "Beds",
                            sortField: 'Family.AvailableBedsString',
                        },
                        {
                            name: 'Family.PhysicalAddress.City',
                            title: "Location",
                            sortField: 'Family.PhysicalAddress.City',
                        },
                        {
                            name: 'CurrentASWName',
                            title: "HSW",
                            sortField: 'CurrentASWName',
                        },
                        {
                            name: 'CurrentRFSName',
                            title: "Specialist",
                            sortField: 'CurrentRFSName',
                        },
                        {
                            name: 'Family.SubProgramTerritoryName',
                            title: "Territory",
                            sortField: 'Family.SubProgramTerritoryName',
                        },
                        {
                            name: 'StatusSpecifier',
                            title: "Status Specifier",
                            sortField: 'StatusSpecifier'
                        },
                        {
                            name: 'StatusNotes',
                            title: "Status Notes",
                            sortField: 'StatusNotes',
                        },
                        {
                            name: 'ChurchName',
                            title: "Church",
                            sortField: 'ChurchName',
                        },
                        {
                            name: 'ParentCount',
                            title: "Parent Count",
                            sortField: 'ParentCount',
                        }
                    ]
                },
                FamilyList: [],
                FamilyServiceLogCategories: [
                    {
                        Label: "Communication",
                        Options: [
                            {
                                value: "Communication With Family"
                            },
                            {
                                value: "Communication With Regulatory Agency"
                            },
                            {
                                value: "Communication With Other"
                            }
                        ]
                    },
                    {
                        Label: "Approval/Licensing Process",
                        Options: [
                            {
                                value: "Approval/Licensing Note"
                            }
                        ]
                    },
                    {
                        Label: "Misc",
                        Options: [
                            {
                                value: "Incident"
                            },
                            {
                                value: "Informational"
                            },
                            {
                                value: "Other"
                            }
                        ]
                    }
                ]
            };
        },
        methods: {
            RefreshDataTable() {
                this.GetFamilies(true);
            },
            GetFamiliesSingularRecord(SingleRecordID = null) {
                var vm = this;
                let openRecords = [];
                Object.keys(this.$store.state.Families.FamilyProfiles).map(function (key, index) {
                    openRecords.push(vm.$store.state.Families.FamilyProfiles[key].Family.Id)
                });
                //vm.$store.commit("UI.BumpLoadsInProgress", 1);
                this.$MasterAPI.ExecuteRequest("POST", "Foster/ResourceFamily/GetResourceFamiliesSingularRecord",
                    {
                        Status: vm.Filters.FamilyStatus,
                        SubProgramID: vm.Filters.SubProgramID,
                        ASWID: vm.Filters.ASWID,
                        AdditionalRecords: openRecords,
                        SingleRecordID: SingleRecordID
                    }, this.GetFamiliesSingularRecordSuccess, () => { }, false);
            },
            GetFamiliesSingularRecordSuccess(response) {
                this.$store.commit("Families.FamilyProfiles.Append",response.data.data[0]);
            },
            GetFamilies(displayLoad = false) {
                var vm = this;
                let openRecords = [];
                Object.keys(this.$store.state.Families.FamilyProfiles).map(function (key, index) {
                    openRecords.push(vm.$store.state.Families.FamilyProfiles[key].Family.Id)
                });
                this.$MasterAPI.ExecuteRequest("POST", "Foster/ResourceFamily/GetResourceFamilies",
                    {
                        Status: vm.Filters.FamilyStatus,
                        SubProgramID: vm.Filters.SubProgramID,
                        ASWID: vm.Filters.ASWID,
                        AdditionalRecords: openRecords
                    }, this.GetFamiliesSuccess, () => { }, displayLoad);
            },
            GetFamiliesSuccess(response) {
                this.FamilyList = response.data.data.FamilyList;
                this.$store.commit("Families.FamilyEnrollmentsList.ReplaceListOnly", this.FamilyList);
                this.NumberOfFamilies = response.data.data.FamilyList.length;
                this.RefreshTableFields(response);
                this.$refs.datatable.refresh();
            },
            OpenServiceLogAdder(chartID, chartName) {
                this.$refs.familyservicelogaddercomponent.OpenAddRecord(chartID, chartName);
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.FamilyList);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }
                    
                } else {
                    return [];
                }
            },
            onRowClass(dataItem, index) {
                return (dataItem.Family.Status == "Active (Placement Hold)" || dataItem.Family.Status == "Active (Suspended)") ? 'red' : ''
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));
                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                this.NumberOfFamilies = visibleData.length;
                return visibleData;                  
            },
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            OpenFamilyRecord(familyID, familyRecordData) {
                this.GetFamiliesSingularRecord(familyID);

                this.$parent.ChangePaneShown(familyID);
            },
            StyleFamilyName(rowData) {
                var lastName = "<b>" + rowData.Family.Name.split(',')[0] + "</b>";
                var firstName = rowData.Family.Name.split(',')[1] === undefined ? "" : ", " + rowData.Family.Name.split(',')[1];
                return lastName + firstName;
            },
            getCurrentASWName(value) {
                let initList = value.filter(asws => asws.EndDate == null);
                if (initList.length == 1) {
                    return initList[0].Employee.Person.FullName;
                } else {
                    return null;
                }
            },
            SortTable(sortOrder, pagination) {
                return { data: this.LoadedChildren };
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            CheckRestriction(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckRestriction"](permissionName);
            },
            RefreshTableFields(response) {
                let vm = this;
                let outputArray = response.data.data.Columns.toString().split(',');
                let outputFields = [];

                //save fields from frontend that contain the property save.
                let columnsToSave = [];
                this.FamilyTableOptions.Fields.forEach(function (col) {
                    if (col.hasOwnProperty("Save")) {
                        columnsToSave.push(col);
                    }
                });

                for (var i = 0; i < outputArray.length; i++)
                {
                    let fieldExists = this.FamilyTableOptions.Fields.map(function (vc) { return vc.name; }).indexOf(outputArray[i]);
                    if (fieldExists != -1) {
                        outputFields[i] = this.FamilyTableOptions.Fields[fieldExists];
                    }
                }
                this.VisibleFields = outputFields.concat(columnsToSave);
                this.$nextTick(function () {
                    vm.$refs.datatable.normalizeFields();
                });
            }
        },
        components: {
            Vuetable,
            EmployeeColumnCustomizationEditor,
            ServiceLogAdder
        },
        computed: {
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            },
            cssProps() {
                return {
                    '--table-width': this.WidthOfTable
                }
            }
        },
        mounted() {
            this.Filters.SubProgramID = this.SubProgramOptions[0].value;
            var vm = this;
            //Get Child Records*/
            this.GetFamilies(true);
            //let getfamiliesFunc = function () {
            //    vm.GetFamilies();
            //};
            //this.$GlobalUpdate.AddGlobalUpdateFunction(getfamiliesFunc);
        },
    }
</script>

<style scoped>
    /*sticky table header*/
    /deep/ .vue-datatable thead {
        position: sticky;
        top: -1px;
        background: white;
    }
    /*no wrap text on columns*/
    /deep/ .vue-datatable tbody td {
        white-space: nowrap !important;
    }
</style>